export default {"src":"/_next/static/media/calculator_24.1f7fa715.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};